/* eslint-disable max-lines */
export const RAPPI_TRAVEL_TERMS = {
  Header: 'TÉRMINOS Y CONDICIONES DE RAPPI TRAVEL.',
  Body: [
    {
      Title: null,
      Paragraphs: [
        `
        <div>
          <p><span>Rappi S.A.C, identificada con RUC N&deg; 20602985971 es una sociedad
              legalmente constituida bajo las leyes de la Rep&uacute;blica de Per&uacute;, y que en adelante se
              denominar&aacute;
              &ldquo;<u>Rappi Travel</u>&rdquo; o la &ldquo;<u>Agencia</u>&rdquo;. La Agencia act&uacute;a como intermediario
              entre los usuarios o viajeros y las entidades o personas encargadas de proporcionar los servicios de transporte
              a&eacute;reo o terrestre, alojamiento, alimentaci&oacute;n, o cualquier otro servicio y que en adelante se
              denominar&aacute; &ldquo;<u>el Proveedor/ los Proveedores</u>&rdquo; contratado(s) a trav&eacute;s del sitio de
              Internet o Plataforma Virtual de esta Agencia de Viajes (el &ldquo;<u>Sitio web</u>&rdquo;).</span></p>
          <p><span>Los presentes T&eacute;rminos y Condiciones (&ldquo;<u>T&eacute;rminos y
                Condiciones</u>&rdquo;) regulan el v&iacute;nculo contractual entre Rappi S.A.C. (&ldquo;Rappi Travel&rdquo;) y
              los usuarios (&ldquo;<u>Usted</u>&rdquo; o &ldquo;<u>Usuario(s)</u>&rdquo;) que contraten servicios
              tur&iacute;sticos con la intermediaci&oacute;n de la Agencia.</span></p>
          <p><span>EL USUARIO DECLARA HABER LE&Iacute;DO Y ENTENDIDO TODAS LAS CONDICIONES
              ESTABLECIDAS EN LAS POL&Iacute;TICAS DE PRIVACIDAD Y LOS PRESENTES T&Eacute;RMINOS Y CONDICIONES, Y MANIFIESTA SU
              CONFORMIDAD Y ACEPTACI&Oacute;N AL MOMENTO DE REGISTRARSE Y/O HACER USO DE RAPPI TRAVEL. CUALQUIER USUARIO QUE NO
              ACEPTE O SE ENCUENTRE EN DESACUERDO CON ESTOS T&Eacute;RMINOS Y CONDICIONES, LOS CUALES TIENEN UN CAR&Aacute;CTER
              OBLIGATORIO Y VINCULANTE, DEBER&Aacute; ABSTENERSE DE UTILIZAR EL SITIO WEB Y/O EL APLICATIVO.</span></p>
          <h3>
            <strong><span>1. CONSIDERACIONES GENERALES.</span></strong>
          </h3>
          <h3>
            <strong><span>1.1</span></strong>
          </h3>
          <p><span>Rappi Travel es una agencia de viajes que ofrece servicios solo por canales
              digitales a trav&eacute;s del bot&oacute;n denominado &ldquo;Rappi Travel&rdquo; (&ldquo;<u>Rappi
                Travel</u>&rdquo;)
              ubicado dentro de la plataforma virtual y/o sitio web de propiedad de Rappi S.A.C.
              (&ldquo;<u>Rappi</u>&rdquo;).</span></p>
          <h3>
            <strong><span>1.2</span></strong>
          </h3>
          <p><span>Rappi Travel facilita la intermediaci&oacute;n entre los Usuarios de los
              servicios de hoteler&iacute;a, vuelos, y cualquier otro tipo de servicio asociado al turismo (colectivamente
              &ldquo;<u>Servicios Tur&iacute;sticos</u>&rdquo;) y prestadores y Proveedores de Servicios Tur&iacute;sticos
              (&ldquo;<u>Proveedor(es)</u>&rdquo;). Por intermedio de Rappi Travel, los Proveedores podr&aacute;n ofrecer y
              publicitar los Servicios Tur&iacute;sticos que brindan y, por su parte, los Usuarios podr&aacute;n reservar dichos
              Servicios Tur&iacute;sticos en tiempo real y contratarlos por separado o combinados, armando y gestionando su
              propio
              viaje, de conformidad con sus intereses particulares.</span></p>
          <h3>
            <strong><span>1.3</span></strong>
          </h3>
          <p><span>El Usuario contrata los Servicios Tur&iacute;sticos directamente con su
              respectivo Proveedor, con la intermediaci&oacute;n de Rappi Travel, es importante aclarar que Rappi Travel no es
              el
              proveedor de los Servicios Tur&iacute;sticos, por lo tanto, no est&aacute; obligado directa ni indirectamente a la
              ejecuci&oacute;n del Servicio Tur&iacute;stico contratado por el Usuario a trav&eacute;s de Rappi Travel.</span>
          </p>
          <h3>
            <strong><span>1.4</span></strong>
          </h3>
          <p><span>Al contratar Servicios Tur&iacute;sticos a trav&eacute;s de Rappi Travel,
              Usted garantiza que: (i) es mayor de edad; (ii) acepta expresamente los presentes T&eacute;rminos y Condiciones
              (iii) posee plena capacidad para celebrar contratos; (iv) solo utiliza Rappi Travel para reservar o contratar
              Servicios Tur&iacute;sticos para Usted y/o para otra persona respecto de quien tenga facultades suficientes para
              representar; y (v) toda la informaci&oacute;n que Usted brinda a Rappi Travel es ver&iacute;dica, exacta, actual y
              completa.</span></p>
          <h3>
            <strong><span>1.5</span></strong>
          </h3>
          <p><span>Estas condiciones solamente rigen la relaci&oacute;n entre Usted y Rappi
              Travel, esto es, las previsiones contenidas en los presentes T&eacute;rminos y Condiciones &uacute;nicamente se
              aplican a los servicios de intermediaci&oacute;n prestados por Rappi Travel en calidad de agencia de viajes y bajo
              ning&uacute;n supuesto reemplazan o modifican las condiciones especiales que cada Proveedor defina para los
              Servicios Tur&iacute;sticos que preste. Por tal motivo, antes de formular una solicitud de compra en
              relaci&oacute;n
              con los Servicios Tur&iacute;sticos a trav&eacute;s de Rappi Travel y previa aceptaci&oacute;n de los presentes
              T&eacute;rminos y Condiciones (la &ldquo;<u>Solicitud de Compra</u>&rdquo;), la Agencia recomienda a los Usuarios
              revisar los t&eacute;rminos y condiciones particulares y las restricciones aplicables al Servicio Tur&iacute;stico
              que desea contratar previstos por sus respectivos Proveedores. Rappi Travel no controla ni participa en el
              establecimiento de las pol&iacute;ticas previstas por los Proveedores de los Servicios Tur&iacute;sticos, por
              tanto,
              no se hace responsable por tales previsiones.</span></p>
          <h3>
            <strong><span>1.6</span></strong>
          </h3>
          <p><span>Rappi Travel deja constancia de que su actividad de intermediaci&oacute;n
              en la comercializaci&oacute;n de Servicios Tur&iacute;sticos no garantiza que el destino elegido no presente
              riesgos
              para la salud e integridad de las personas. La Agencia no es responsable ni directa ni indirectamente por los
              da&ntilde;os o p&eacute;rdidas que de cualquier modo Usted o quienes viajen junto a Usted puedan sufrir antes,
              durante o como consecuencia del destino elegido. Rappi Travel no se responsabiliza por ninguna clase de
              situaci&oacute;n de fuerza mayor (accidentes, huelgas, asonadas, terremotos, fen&oacute;menos clim&aacute;ticos o
              naturales, condiciones de seguridad, factores pol&iacute;ticos, negaci&oacute;n de permisos de ingreso, asuntos de
              salubridad y cualquier otro), caso fortuito, hecho exclusivo de la v&iacute;ctima, o de un tercero por el cual no
              deba responder, que pudieran acontecer antes o durante la prestaci&oacute;n del Servicio Tur&iacute;stico, y que
              pudieran eventualmente demorar, interrumpir o impedir la ejecuci&oacute;n del mismo.</span></p>
          <h3>
            <strong><span>2. SOLICITUD DE COMPRA Y CONTRATACI&Oacute;N DE LOS SERVICIOS.</span></strong>
          </h3>
          <h3>
            <strong><span>2.1</span></strong>
          </h3>
          <p><span>Cuando Usted env&iacute;a una Solicitud de Compra a trav&eacute;s de Rappi
              Travel, autoriza a la Agencia a gestionar su reserva y a realizar los cargos correspondientes a su cuenta o
              tarjeta.
              Le recomendamos prestar mucha atenci&oacute;n a nuestras comunicaciones posteriores, porque por medio de las
              mismas
              le notificaremos los avances y el estado de su Solicitud de Compra. El buen t&eacute;rmino de la gesti&oacute;n de
              la Solicitud de Compra y/o la confirmaci&oacute;n de la misma, dependen del pago &iacute;ntegro y oportuno del
              precio de todos los Servicios Tur&iacute;sticos. Mientras no se efect&uacute;e el pago total del precio
              establecido
              para los Servicios Tur&iacute;sticos que se pretenden contratar, la Solicitud de Compra quedar&aacute; en espera y
              podr&iacute;a ser cancelada por el respectivo Proveedor. La confirmaci&oacute;n definitiva de los Servicios
              Tur&iacute;sticos y precios respectivos se producir&aacute; con la emisi&oacute;n del tiquete electr&oacute;nico
              y/o
              voucher del servicio. La emisi&oacute;n del tiquete electr&oacute;nico y/o voucher del servicio es prueba
              suficiente
              de la aceptaci&oacute;n de las condiciones del Proveedor y la celebraci&oacute;n del contrato suscrito entre el
              Proveedor y la persona cuyos datos constan en dicho tiquete electr&oacute;nico y/o voucher del servicio.</span>
          </p>
          <h3>
            <strong><span>2.2</span></strong>
          </h3>
          <p><span>Si la Solicitud de Compra quedar&aacute; sujeta a confirmaci&oacute;n
              -circunstancia que le ser&aacute; informada en la primera comunicaci&oacute;n que reciba- los valores pagados
              antes
              de la confirmaci&oacute;n ser&aacute;n recibidos bajo concepto de reserva. Si finalmente su Solicitud de Compra
              fuera rechazada por cualquier motivo (por ejemplo, por saldo insuficiente en su tarjeta de cr&eacute;dito, por
              falta
              de disponibilidad, por variaci&oacute;n en la tarifa, etc.), Rappi Travel proceder&aacute; a informarle las
              opciones
              disponibles para el caso en que Usted. desee insistir en la compra o reserva o, a su requerimiento, le
              devolver&aacute; los importes abonados.</span></p>
          <h3>
            <strong><span>2.3</span></strong>
          </h3>
          <p><span>Antes de contratar, el Usuario se obliga a revisar las condiciones
              particulares de cada Servicio Tur&iacute;stico y de cada Proveedor. Rappi Travel no se hace responsable ni tiene
              injerencia en las condiciones particulares establecidas por cada Proveedor para la prestaci&oacute;n de sus
              Servicios Tur&iacute;sticos. Estas condiciones son las de car&aacute;cter general que se aplican a los servicios
              de
              intermediaci&oacute;n que le presta La Agencia y bajo ning&uacute;n aspecto reemplazan o modifican las
              limitaciones
              de responsabilidad legalmente establecidas, ni a las condiciones especiales que cada Proveedor Tur&iacute;stico ha
              definido para sus Servicios Tur&iacute;sticos</span></p>
          <h3>
            <strong><span>3. DATOS PERSONALES</span></strong>
          </h3>
          <h3>
            <strong><span>3.1</span></strong>
          </h3>
          <p><span>Rappi Travel se preocupa por la privacidad de los Usuarios que contraten
              Servicios Tur&iacute;sticos a trav&eacute;s de Rappi Travel. La Agencia y Rappi recogen, utilizan y comparten
              informaci&oacute;n de identificaci&oacute;n personal e informaci&oacute;n de identificaci&oacute;n no personal.
              Usted acepta que: (i) al acceder a Rappi Travel y/o al contratar Servicios Tur&iacute;sticos con la
              intermediaci&oacute;n de La Agencia est&aacute; consintiendo la recopilaci&oacute;n de dicha informaci&oacute;n; y
              (ii) sus datos de car&aacute;cter personal sean recogidos, usados, transferidos y procesados de acuerdo a la
              <u>Pol&iacute;tica de Privacidad de Rappi y Tratamiento de Datos Personales</u> y la Ley N&deg; 29733, Ley de
              Protecci&oacute;n de Datos Personales y el Decreto Supremo N&deg; 003-2013-JUS, Reglamento de la Ley de
              Protecci&oacute;n de Datos Personales.</span></p>
          <h3>
            <strong><span>3.2</span></strong>
          </h3>
          <p><span>Usted deber&aacute; completar todos los campos con datos exactos para poder
              realizar reservas v&aacute;lidas de Servicios Tur&iacute;sticos a trav&eacute;s de Rappi Travel. Al ingresar sus
              datos personales en la Plataforma, Usted declara que dichos datos (los &ldquo;Datos Personales&rdquo;) son
              exactos,
              precisos y verdaderos, y asume el compromiso de actualizar dichos Datos Personales conforme resulte necesario.
              Rappi
              Travel no se responsabiliza por la certeza de los Datos Personales provistos por Usted. Usted garantiza y responde
              por la veracidad, exactitud, vigencia y autenticidad de los Datos Personales ingresados. Recuerde que todos sus
              datos deber&aacute;n coincidir en forma exacta con la Documentaci&oacute;n de Viaje.</span></p>
          <h3>
            <strong><span>3.3</span></strong>
          </h3>
          <p><span>Usted al ingresar con su usuario en la plataforma de Rappi a trav&eacute;s
              del bot&oacute;n denominado Rappi Travel, se tomar&aacute; su direcci&oacute;n de correo electr&oacute;nico el
              cual
              es nuestra v&iacute;a de contacto con Usted. Revise que el correo electr&oacute;nico proporcionado como punto de
              contacto sea correcto y mant&eacute;ngase atento a la informaci&oacute;n que se le enviar&aacute; a dicho correo.
              Se
              considerar&aacute; que Usted tom&oacute; conocimiento oportuno de la confirmaci&oacute;n de su Solicitud de
              Compra,
              pol&iacute;ticas de cambios, cancelaciones y reembolsos o de alg&uacute;n inconveniente o variaci&oacute;n a la
              misma con el env&iacute;o de dicha informaci&oacute;n al correo electr&oacute;nico proporcionado por Usted. Tenga
              presente que si el correo electr&oacute;nico ingresado por Usted. contiene alg&uacute;n error no recibir&aacute;
              comunicaciones fundamentales para la gesti&oacute;n de su Solicitud de Compra. De todas maneras, Usted puede
              ingresar a la secci&oacute;n de la plataforma denominada &ldquo;Mis Viajes&rdquo; all&iacute; podr&aacute;
              verificar
              el estado del proceso de su compra.</span></p>
          <h3>
            <strong><span>3.4</span></strong>
          </h3>
          <p><span>Usted deber&aacute; ingresar sus datos de facturaci&oacute;n exactos en el
              apartado &ldquo;Datos de Facturaci&oacute;n&rdquo; para poder emitirle la correspondiente boleta o factura. Usted
              declara que dichos datos son exactos, precisos y verdaderos. Rappi Travel no ser&aacute; responsable por la
              emisi&oacute;n de documentos con informaci&oacute;n incorrecta proporcionada por Usted. Usted garantiza y responde
              por la veracidad, exactitud, vigencia y autenticidad de los datos fiscales ingresados. La actualizaci&oacute;n de
              los Datos Personales mencionados en el punto 3.2, no afectar&aacute;n los datos de facturaci&oacute;n
              proporcionados
              por Usted. En el caso de registrarse inconsistencias entre los datos de facturaci&oacute;n proporcionados por
              Usted
              y los reflejados en el comprobante de pago (boleta o factura), el Usuario podr&aacute; solicitar a trav&eacute;s
              del
              &aacute;rea de soporte de Rappi Travel, </span><span>&nbsp;</span><span>, la correcci&oacute;n de la boleta o
              factura</span><span><span>, lo cual deber&aacute; solicitarse dentro de los treinta
                (30) d&iacute;as de efectuada la compra</span></span><span>.
              E</span><span>&nbsp;</span></p>
          <h3>
            <strong><span>4. INFORMACI&Oacute;N</span></strong>
          </h3>
          <h3>
            <strong><span>4.1</span></strong>
          </h3>
          <p><span>La informaci&oacute;n publicada en Rappi Travel relativa a precios,
              cualidades y caracter&iacute;sticas de los Servicios Tur&iacute;sticos, su disponibilidad, condiciones de venta,
              restricciones, pol&iacute;ticas de cancelaci&oacute;n o reembolso (entre otras) es establecida y proporcionada por
              los Proveedores de los Servicios Tur&iacute;sticos en l&iacute;nea y en tiempo real. En su calidad de
              intermediario,
              Rappi Travel le informa acerca de las caracter&iacute;sticas de los Servicios Tur&iacute;sticos, gestiona sus
              Solicitudes de Compra con los Proveedores, recauda, de ser aplicable, los valores correspondientes a los precios y
              le brinda apoyo en la b&uacute;squeda de soluciones en caso de presentarse una inquietud o un inconveniente en
              relaci&oacute;n con la contrataci&oacute;n de los Servicios Tur&iacute;sticos. La Agencia realiza sus mayores
              esfuerzos a fin de brindar informaci&oacute;n correcta y precisa, pero </span><span>&nbsp;</span><span>(como
              errores
              manifiestos y
              tipogr&aacute;ficos), interrupciones (debido a ca&iacute;das temporales y/o parciales del servidor o a
              reparaciones), imprecisiones, informaci&oacute;n enga&ntilde;osa o falsa emanada de los Proveedores de los
              Servicios
              Tur&iacute;sticos. Rappi Travel no es ni debe ser interpretado como un promotor de la calidad, el nivel de
              servicio
              y/o la calificaci&oacute;n o clasificaci&oacute;n de cualquier Servicio Tur&iacute;stico disponible en el sitio
              web
              de La Agencia.</span></p>
          <h3>
            <strong><span>5. ENLACES DE TERCEROS.</span></strong>
          </h3>
          <h3>
            <strong><span>5.1</span></strong>
          </h3>
          <p><span>Rappi Travel puede contener enlaces a sitios web de terceros, anunciantes,
              servicios, ofertas especiales u otros eventos o actividades que no son de propiedad o controlados por La Agencia.
              Rappi Travel no avala, ni asume ninguna responsabilidad en relaci&oacute;n con cualquiera de estos sitios,
              informaci&oacute;n, materiales, productos o servicios de terceros. Si usted accede a un sitio web de terceros
              desde
              Rappi Travel, lo hace bajo su propio riesgo y entiende que los presentes T&eacute;rminos y Condiciones y nuestra
              Pol&iacute;tica de Privacidad de Rappi y Tratamiento de Datos Personales no se aplicar&aacute;n al acceso y uso de
              dichos sitios as&iacute; como a los datos que Usted pueda proporcionar a dichos terceros. Usted libera
              expresamente
              a Rappi Travel de toda responsabilidad derivada del acceso y uso de cualquier sitio web, servicio o contenido de
              terceros y acepta que sus relaciones con cualquier sitio web, servicio o contenido de terceros no implican a La
              Agencia, sino que solo lo incluyen a usted y a dichos terceros.</span></p>
          <h3>
            <strong><span>6. DOCUMENTACI&Oacute;N DE VIAJE</span></strong>
          </h3>
          <h3>
            <strong><span>6.1</span></strong>
          </h3>
          <p><span>&nbsp;</span><span> Verifique con tiempo las
              condiciones de ingreso al pa&iacute;s de destino y/o tr&aacute;nsito, condiciones especiales de visas y/o
              pasaportes, licencias de conducir, vacunas, permiso para menores u otras exigencias de documentos, tanto para los
              pa&iacute;ses de destino, como los pa&iacute;ses en tr&aacute;nsito, a&uacute;n cuando no sea necesario salir del
              aeropuerto. Si la requiere y no dispone de ella, haga los tr&aacute;mites necesarios para obtenerla con
              anticipaci&oacute;n. Los requisitos podr&iacute;an variar seg&uacute;n el pa&iacute;s de destino y/o
              tr&aacute;nsito
              y seg&uacute;n su pa&iacute;s de nacionalidad y/o residencia y/o de la documentaci&oacute;n con la que Usted
              viaje.
              Recuerde que es su responsabilidad cumplir con todos los requisitos y/o documentaci&oacute;n de entrada y/o
              tr&aacute;nsito que exijan las autoridades migratorias, aduaneras y/o sanitarias de el/los pa&iacute;s/es de
              destino/s y/o tr&aacute;nsito. Le aconsejamos que antes de reservar y partir, consulte todos los requisitos
              necesarios con la Embajada o Consulado correspondiente. Para m&aacute;s informaci&oacute;n visite:
            </span><span>&nbsp;</span><span>/. Verifique con antelaci&oacute;n
              la fecha de vencimiento de la documentaci&oacute;n y tenga en cuenta que, en algunos pa&iacute;ses, se exige que
              la
              fecha de expiraci&oacute;n no sea anterior a los seis meses al arribo al territorio extranjero.</span></p>
          <h3>
            <strong><span>6.2</span></strong>
          </h3>
          <p><span>En el caso de viajar con menores de edad adem&aacute;s del documento de
              viaje habilitado (Documento Nacional de Identidad o Pasaporte), necesitan Autorizaci&oacute;n de Viaje para
              menores
              de edad (documento certificado notarialmente por el cual los padres autorizan el viaje de su hijo menor de edad
              dentro o fuera del territorio peruano, para que viaje solo, acompa&ntilde;ado por uno de ellos o por otro adulto)
              que debe tener la firma del notario y tambi&eacute;n: Dentro del pa&iacute;s (i) si el menor viaja solo: la firma
              de
              uno de los padres , (ii) Si el menor viaja con uno de los padres dentro del pa&iacute;s: no se necesita permiso y
              Fuera del pa&iacute;s (i) Si el menor viaja solo: la firma de ambos padres, (ii) Si el menor viaja con uno de los
              padres: la firma del padre o madre que no lo acompa&ntilde;a, (iii) Si el menor viaja con un tercero: la firma de
              ambos padres. La autorizaci&oacute;n tiene una vigencia de 90 d&iacute;as y debe ser entregada a la
              aerol&iacute;nea
              o a la autoridad migratoria peruana para que permita la salida del pa&iacute;s del menor y es v&aacute;lida solo
              por
              una vez. </span></p>
          <p><span>Asimismo, dentro del pa&iacute;s se requiere presentar (i) Partida de
              nacimiento original y actualizada del menor, (ii) DNI del menor de edad, (iii) DNI del padre o de la madre, (iv)
              En
              caso de fallecimiento de uno de los padres o si el hijo est&aacute; reconocido solo por uno de ellos,
              bastar&aacute;
              el consentimiento del padre que sobreviva o de aquel que efectu&oacute; el reconocimiento (el permiso notarial
              debe
              constar haber tenido a la vista la partida de defunci&oacute;n o la de nacimiento correspondiente. </span></p>
          <p><span>En caso de viaje fuera del pa&iacute;s, se requiere presentar (i) Partida
              de nacimiento original y copia del menor de edad, (ii) DNI/Pasaporte del menor de edad, (iii) DNI/Pasaporte de los
              padres, (iii) En el caso de padre extranjeros: el documento de identidad o pasaporte que lo identifique, (iv)
              Cuando
              solo uno de sus padres ha reconocido al menor: basta con el consentimiento de este, (v) Cuando uno de los padres
              ha
              fallecido: copia del acta de defunci&oacute;n, (vi) Si el menor tiene un apoderado: poder y otros documentos que
              lo
              acrediten como tal, (vii) Si uno de los padres se encuentra en el extranjero: Autorizaci&oacute;n de viaje
              consular
              y luego legalizarla en el Ministerio de Relaciones Exteriores del Per&uacute;. (viii) Si el menor cuyo padre o
              madre
              est&aacute; en el extranjero va a viajar con una tercera persona: Autorizaci&oacute;n de viaje consular otorgada
              por
              el padre que est&aacute; fuera del pa&iacute;s, legalizada en el Ministerio de Relaciones Exteriores, y la
              Autorizaci&oacute;n de Viaje Notarial del padre que permanece en el Per&uacute; (el padre que est&aacute; en el
              Per&uacute; y viajar&aacute; con el menor solo necesita la Autorizaci&oacute;n de Viaje Consular legalizada para
              salir del pa&iacute;s con su hijo). Es importante que los datos del documento del menor coincidan con los
              documentos
              presentados por los padres.</span></p>
          <p><span>&nbsp;</span></p>
          <h3>
            <strong><span>7. PRECIOS DE LOS SERVICIOS TUR&Iacute;STICOS Y FORMAS DE PAGO.</span></strong>
          </h3>
          <h3>
            <strong><span>7.1</span></strong>
          </h3>
          <p><span>Cuando el Usuario reserva uno o m&aacute;s Servicios Tur&iacute;sticos a
              trav&eacute;s de Rappi Travel, debe abonar (i) el precio o tarifa fijada por el Proveedor, (ii) los impuestos,
              tasas
              y/o percepciones fiscales aplicables al Servicio Tur&iacute;stico y, en caso de corresponder, (iii) el cargo de
              gesti&oacute;n por el servicio de intermediaci&oacute;n de Rappi Travel (el &ldquo;<u>Cargo de
                Gesti&oacute;n</u>&rdquo;). Es importante mencionar que La Agencia act&uacute;a en nombre y
              representaci&oacute;n
              del Proveedor de los Servicios y que los valores correspondientes al precio o tarifa de los Servicios
              Tur&iacute;sticos son trasladados (endosados) al Proveedor. Rappi Travel podr&aacute; a su discreci&oacute;n
              ofrecer
              distintas modalidades para poder efectuar y abonar sus reservas de Servicios Tur&iacute;sticos dependiendo del
              Servicio a ser adquirido, el Proveedor que lo/s proporcione y el medio utilizado para el pago. Los medios y formas
              de pago disponibles para cada Servicio Tur&iacute;stico son los informados en el Sitio web en forma previa a
              ingresar la solicitud de compra.</span></p>
          <h3>
            <strong><span>7.2</span></strong>
          </h3>
          <p><span>Tenga presente que cuando Usted informa a La Agencia los datos de su cuenta
              o tarjeta de cr&eacute;dito (mediante el formulario disponible en Rappi Travel), y luego acepta o confirma la
              operaci&oacute;n, est&aacute; autoriz&aacute;ndonos a efectuar los cargos por:</span><span>&nbsp;</span><span>Si
              Usted efect&uacute;a una
              reserva en opci&oacute;n cuotas y/o mediante una tarjeta de cr&eacute;dito, tenga presente que:
            </span><span>&nbsp;</span><span>(ii) </span><span>&nbsp;</span><span>se suman al precio o tarifa
              propuesto para el servicio, y dicho total se divide por la cantidad de cuotas seleccionada para el pago. (iii) De
              realizar una cancelaci&oacute;n con posterioridad a la compra, siempre que las condiciones particulares del
              Servicio
              Tur&iacute;stico lo permitan, Rappi Travel no reintegrar&aacute; ni se har&aacute; responsable de los intereses
              que
              la transacci&oacute;n original haya generado, en tanto La Agencia no percibe dichos intereses. (iv) El precio a
              pagar podr&iacute;a ser cobrado en moneda nacional o en d&oacute;lares, seg&uacute;n se trate de prestaciones
              locales o extranjeras. En caso de ser cobrados en d&oacute;lares, el cargo se efectuar&aacute; contra el cupo
              internacional de su tarjeta. En todo caso, cualquiera sea la moneda de cobro, la tarifa o precio ser&aacute;
              aquella
              que le fue informada y que fue aceptada por Usted. (v) Para ciertos destinos y productos, el Proveedor del
              Servicio
              Tur&iacute;stico podr&aacute; cobrarle a Usted directamente por el Servicio Tur&iacute;stico contratado. En estos
              casos, Rappi Travel se lo indicar&aacute; al momento de la compra y Usted recibir&aacute; una boleta o factura
              emitida por dicho Proveedor. Tenga en cuenta que, en estos casos, el cargo podr&aacute; ser efectuado por su
              tarjeta
              de cr&eacute;dito en D&oacute;lares Estadounidenses por el monto en dicha moneda indicado en detalle de su
              pago.</span></p>
          <h3>
            <strong><span>7.3</span></strong>
          </h3>
          <p><span>Si el Usuario realiza el pago con una tarjeta de cr&eacute;dito debe tener
              en cuenta que: (i) a trav&eacute;s del bot&oacute;n &ldquo;Rappi Travel&rdquo; dentro de la plataforma de Rappi se
              recibe como forma de pago las tarjetas locales de cr&eacute;dito y/o d&eacute;bito (aplica restricciones) de las
              franquicias Master Card, Visa, American Express. (ii) Para garantizar su reserva y tarifa, debe realizar el pago
              por
              el valor total y en l&iacute;nea de manera inmediata. (iii) Los datos suministrados por el due&ntilde;o de la
              tarjeta deben ser iguales a los que reposan ante la entidad financiera como son nombres, apellidos, tipo y
              n&uacute;mero de documento, direcci&oacute;n de correspondencia y tel&eacute;fono. (iv) La confirmaci&oacute;n de
              la
              compra, dependen del pago &iacute;ntegro (Total) del precio y/o tarifa de todos los Servicios Tur&iacute;sticos.
              La
              confirmaci&oacute;n definitiva de los Servicios Tur&iacute;sticos y precios se producir&aacute; con la
              emisi&oacute;n de el/los tiquetes electr&oacute;nicos/s y/o vouchers de servicio. (v) Los cargos por servicio son
              cobrados a trav&eacute;s del bot&oacute;n &ldquo;Rappi Travel&rdquo; dentro de la plataforma de contacto Rappi es
              no
              reembolsable en ning&uacute;n caso.</span></p>
          <h3>
            <strong><span>8. CAMBIO O CANCELACI&Oacute;N DE UNA SOLICITUD DE COMPRA
                CONFIRMADA</span></strong>
          </h3>
          <h3>
            <strong><span>8.1</span></strong>
          </h3>
          <p><span>Si solicita un cambio o cancelaci&oacute;n del Servicio Tur&iacute;stico
              contratado y si este lo permitiera, Rappi Travel realizar&aacute; las gestiones de presentaci&oacute;n y
              seguimiento
              de su solicitud, pero, tanto los plazos de contestaci&oacute;n como la decisi&oacute;n final, ser&aacute;n del
              Proveedor del Servicio Tur&iacute;stico. La forma de proceder y las condiciones especiales que rigen para casos de
              cambios o cancelaciones de una Solicitud de Compra confirmada, son determinadas por los Proveedores de los
              Servicios
              Tur&iacute;sticos, quienes podr&aacute;n establecer multas o penalidades aplicables para los cambios solicitados.
              Estas condiciones est&aacute;n disponibles para su consulta en Rappi Travel, se recomienda que las revise
              atentamente antes de generar una Solicitud de Compra y recuerde que hay Servicios Tur&iacute;sticos que, por
              disposici&oacute;n de los Proveedores, no admiten cambios y/o devoluciones, o los admiten con restricciones y/o
              con
              penalidades.</span></p>
          <h3>
            <strong><span>8.2</span></strong>
          </h3>
          <p><span>Las gestiones en Rappi Travel se realizan on-line y en tiempo real. Cuando
              Usted solicita un cambio, est&aacute; cancelando una Solicitud de Compra confirmada y generando otra nueva que se
              regir&aacute; por las condiciones particulares aplicables al momento en el que Usted realiza el cambio, por lo
              cual,
              adem&aacute;s de las penalidades aplicables, podr&iacute;a existir una diferencia de precio que consiste en el
              valor
              que resulte de la diferencia entre el precio originalmente abonado por los Servicios Tur&iacute;sticos contratados
              y
              el nuevo precio vigente al momento de efectuar el cambio (la &ldquo;Diferencia de Tarifa&rdquo;). Recuerde que los
              precios por los Servicios Tur&iacute;sticos son din&aacute;micos y dependen de variables como anticipaci&oacute;n
              de
              compra, fechas de viaje, promociones estacionales y, en el caso de vuelos, tambi&eacute;n de las restricciones
              tarifarias (a mayores restricciones, mayor precio).</span></p>
          <h3>
            <strong><span>8.3</span></strong>
          </h3>
          <p><span>En el caso de devoluciones aprobadas por el Proveedor, estas podr&aacute;n
              ser efectuadas mediante un cr&eacute;dito o una reversi&oacute;n de cargo a la misma tarjeta con la cual se
              realiz&oacute; la Solicitud de Compra, previa autorizaci&oacute;n del titular de la tarjeta de cr&eacute;dito. Si
              el
              pago fue realizado en efectivo y/o transferencia bancaria, Rappi Travel le requerir&aacute; sus datos bancarios
              para
              realizar el reembolso mediante transferencia bancaria. Los plazos de reembolso y/o de la reversi&oacute;n de cargo
              depender&aacute;n de cada Proveedor, ya que Rappi Travel solo act&uacute;a como intermediario y dicho reembolso se
              tiene que ver con el Proveedor espec&iacute;fico (en algunos casos, como lo pudiere ser el de
              compa&ntilde;&iacute;as a&eacute;reas, los plazos pudieren llegar a tardar entre 30 y 120 d&iacute;as).</span></p>
          <h3>
            <strong><span>8.4</span></strong>
          </h3>
          <p><span>El Usuario deber&aacute; cumplir con los requisitos para el tr&aacute;mite
              seg&uacute;n el tipo de servicio adquirido y siempre que la tarifa seleccionada por el Usuario permita el proceso
              correspondiente, Rappi Travel realizar&aacute; las gestiones de presentaci&oacute;n, proceso y seguimiento de su
              solicitud, pero la decisi&oacute;n de autorizar o negar ser&aacute; &uacute;nicamente del Proveedor del Servicio
              Tur&iacute;stico, quienes podr&aacute;n establecer multas o penalidades aplicables para los cambios, cancelaciones
              solicitados.</span></p>
          <h3>
            <strong><span>8.5</span></strong>
          </h3>
          <p><span>Es importante informar que las pol&iacute;ticas y/o condiciones de compra
              se encuentran disponibles en el bot&oacute;n denominado &ldquo;Rappi Travel&rdquo; dentro de la plataforma de
              contacto Rappi, y en los vouchers de confirmaci&oacute;n del servicio enviado al correo electr&oacute;nico
              registrado por Usuario en el proceso de la compra; las condiciones especiales que rigen para casos de cambios o
              cancelaciones en una reserva son determinadas por los Proveedores de los Servicios Tur&iacute;sticos, quienes
              podr&aacute;n cobrar penalidades las cuales son aplicables para los cambios y/o cancelaciones solicitados.
              Adicionalmente algunas tarifas y/o productos por disposici&oacute;n de los Proveedores, no admiten cambios y/o
              devoluciones, o los admiten con restricciones y/o con penalidades, a&uacute;n en casos de enfermedad, huelga,
              fen&oacute;menos clim&aacute;ticos, entre otros. Tenga en cuenta que cada Proveedor define sus penalidades sin
              intervenci&oacute;n de Rappi Travel.</span></p>
          <h3>
            <strong><span>8.6</span></strong>
          </h3>
          <p><span>Los Proveedores de servicios no est&aacute;n obligados a excluir las
              condiciones del contrato a&uacute;n en casos soportados de enfermedad o incapacidad f&iacute;sica que les impida
              viajar; es decir que, si la tarifa pagada dispone de cobro de penalidad para realizar modificaciones y/o
              devoluciones o no permite cambios y/o reintegro, el Proveedor del servicio tur&iacute;stico puede cobrar esos
              cargos
              o negar la devoluci&oacute;n del costo de la reserva. Tenga en cuenta que cada Proveedor define sus penalidades
              sin
              intervenci&oacute;n de Rappi Travel.</span></p>
          <h3>
            <strong><span>8.7</span></strong>
          </h3>
          <p><span>El cargo por servicio cobrada por Rappi Travel es de car&aacute;cter no
              reembolsable. En caso de cancelaci&oacute;n de reservas confirmadas por cualquier motivo, este cargo de
              gesti&oacute;n no ser&aacute; reintegrado ya que corresponde a un servicio efectivamente prestado por La Agencia.
              As&iacute; mismo, en el supuesto de que el Usuario solicite el cambio o la cancelaci&oacute;n de un Servicio
              Tur&iacute;stico, Rappi Travel podr&aacute; cobrar un cargo de gesti&oacute;n adicional.</span></p>
          <h3>
            <strong><span>8.8</span></strong>
          </h3>
          <p><span>Realizar una cancelaci&oacute;n despu&eacute;s de la compra, siempre que
              las condiciones propias del Servicio Tur&iacute;stico lo permitan, tenga en cuenta que Rappi Travel no
              reintegrar&aacute; ni se har&aacute; responsable de los intereses que la transacci&oacute;n original haya
              generado,
              toda vez que La Agencia no cobra dichos intereses.</span></p>
          <h3>
            <strong><span>9. CONDICIONES ESPECIALES DE SERVICIOS TUR&Iacute;STICOS CON DESTINO
                CUBA.</span></strong>
          </h3>
          <h3>
            <strong><span>9.1</span></strong>
          </h3>
          <p><span>Seg&uacute;n las regulaciones vigentes en Estados Unidos, los viajes a Cuba
              para actividades tur&iacute;sticas se encuentran vetados para ciudadanos, residentes o personas sujetas a la
              jurisdicci&oacute;n Norteamericana. Esta regla tiene algunas excepciones (como, por ejemplo: visitas familiares;
              trabajo oficial para el gobierno de Estados Unidos, gobiernos extranjeros y algunas organizaciones no
              gubernamentales; actividad period&iacute;stica; investigaci&oacute;n y reuniones profesionales; etc.). Actualmente
              Rappi Travel no cuenta con los recursos para poder verificar estas excepciones durante el proceso de compra
              online,
              por lo que moment&aacute;neamente no nos encontramos en condiciones de poder ofrecer este destino a ciudadanos
              comprendidos en las referidas excepciones. M&aacute;s informaci&oacute;n en
              https://cu.usembassy.gov/es/u-s-citizen-services-es/local-resources-of-u-s-citizens- es/viajes-a-cuba/</span></p>
          <h3>
            <strong><span>10. PROCEDIMIENTO PARA CONSULTAS O RECLAMOS</span></strong>
          </h3>
          <h3>
            <strong><span>10.1</span></strong>
          </h3>
          <p><span>En el caso de que Usted necesite efectuar un reclamo y/o consulta,
              solicitar modificaciones y/o cancelaciones (de ser esto posible), solicitar el re-env&iacute;o tickets, voucher
              y/o
              requerir su factura, Usted podr&aacute; acceder durante las 24 horas a Rappi Travel con su n&uacute;mero de orden
              y/o Id Itinerario, donde podr&aacute; realizar cualquier gesti&oacute;n a trav&eacute;s del bot&oacute;n soporte
              el
              cual est&aacute; disponible en la parte inferior del APP (aplicaci&oacute;n para dispositivos m&oacute;viles) de
              Rappi.</span></p>
          <h3>
            <strong><span>10.2</span></strong>
          </h3>
          <p><span>En el caso de querer realizar un reclamo, sugerencia o consulta, se
              recomienda realizar una descripci&oacute;n detallada de los hechos adjuntando de inmediato la copia de los
              antecedentes de respaldo, explicando lo ocurrido y formulando en t&eacute;rminos claros y simples la
              soluci&oacute;n
              que desea. De esta manera podremos revisar su caso en forma m&aacute;s r&aacute;pida y eficiente. Rappi Travel
              analizar&aacute; el reclamo, y dar&aacute; respuesta al mismo correo electr&oacute;nico informado por Usted lo
              antes
              posible. Si de la revisi&oacute;n de los antecedentes resultara procedente acoger en todo o en parte el reclamo,
              La
              Agencia se lo har&aacute; saber y le enviar&aacute; por mail el correspondiente acuerdo junto con las
              instrucciones
              correspondientes. Lo anterior, sin perjuicio de que Rappi Travel podr&iacute;a ofrecerle una soluci&oacute;n
              alternativa, diferente a las peticiones formuladas por Usted. Se aclara que para realizar cualquier solicitud en
              relaci&oacute;n con lo anterior, podr&aacute;s acceder durante las 24 horas, con tu n&uacute;mero de orden y
              realizar cualquier gesti&oacute;n relacionada a trav&eacute;s del bot&oacute;n de soporte, el cual est&aacute;
              disponible en la parte inferior del App de Rappi (Rappi Travel).</span></p>
          <h3>
            <strong><span>10.3</span></strong>
          </h3>
          <p><span>Los cambios o cancelaciones de reservas efectuadas con nuestra
              intermediaci&oacute;n, si bien son regidos por las pol&iacute;ticas establecidas por los respectivos Proveedores
              de
              los Servicios Tur&iacute;sticos, deben ser gestionados a trav&eacute;s de Rappi Travel. En cualquiera de los casos
              anteriores, el respectivo Proveedor lo derivar&aacute; con nosotros.</span></p>
          <h3>
            <strong><span>11. TERMINOS Y CONDICIONES POR CADA PRODUCTO DE SERVICIO DE
                TURISMO</span></strong>
          </h3>
          <h3>
            <strong><span>11.1</span></strong>
          </h3>
          <p><span>Tenga muy presente que cada Proveedor tiene sus propias pol&iacute;ticas
              para la provisi&oacute;n de sus Servicios Tur&iacute;sticos. Cuando revise las pol&iacute;ticas, sin perjuicio de
              los dem&aacute;s temas de su inter&eacute;s, preste atenci&oacute;n a los siguientes puntos:</span></p>
          <h3>
            <strong><span>VUELOS Y/O A&Eacute;REOS</span></strong>
          </h3>
          <p><span>El transporte a&eacute;reo se encuentra regulado por la Ley de
              Aeron&aacute;utica Civil del Per&uacute; y su reglamento, que acuerdan ciertas obligaciones sobre transportistas,
              y
              le otorgan a Usted ciertos derechos en calidad de Pasajero. Estas regulaciones podr&aacute;n ser consultadas en el
            </span><span>&nbsp;</span><span>:
              http://transparencia.mtc.gob.pe/idm_docs/normas_legales/1_0_8.pdf. A su vez, cada compa&ntilde;&iacute;a
              a&eacute;rea (la &ldquo;<u>Compa&ntilde;&iacute;a A&eacute;rea</u>&rdquo;) establece sus propias regulaciones
              tarifarias para la comercializaci&oacute;n de pasajes a&eacute;reos (el/los &ldquo;<u>Pasaje/s
                A&eacute;reo/s</u>&rdquo;).</span></p>
                <h3><strong><span>POL&Iacute;TICA DE CANCELACI&Oacute;N GRATUITA – BOLETOS A&Eacute;REOS</span></strong></h3>
                <p><span>Para poder acceder al presente beneficio de cancelaci&oacute;n gratuita de boletos 
                a&eacute;reos (en adelante, el/los “Boleto/s A&eacute;reo/s”), se deben cumplir con las siguientes 
                condiciones:</span></p><br>
                <ol>
                  <li>La fecha de emisi&oacute;n y la fecha de cancelaci&oacute;n del Boleto A&eacute;reo, debe ser la 
                  misma con base a la zona horaria de Per&uacute;.</li><br>
                  <li>El Boleto A&eacute;reo solo podr&aacute; ser cancelado sin penalidad hasta las 11:59 pm del 
                  d&iacute;a de emisi&oacute;n del mismo. No obstante, se aclara que, desde las 11:45 pm hasta 
                  las 11:59 pm, el proceso de cancelaci&oacute;n se lleva a cabo de manera manual, por lo tanto, 
                  durante ese plazo los usuarios deber&aacute;n contactarse a trav&eacute;s del canal de soporte 
                  de Rappi Travel (bot&oacute;n de “Ayuda” dentro de Rappi Travel) para solicitar la 
                  cancelaci&oacute;n gratuita de su Boleto A&eacute;reo; es decir, durante ese plazo no es posible 
                  solicitarlo por medio de la secci&oacute;n MIS VIAJES de Rappi Travel. En todos los supuestos, 
                  se validar&aacute; que la solicitud de cancelaci&oacute;n gratuita se realice dentro del mismo 
                  d&iacute;a de emisi&oacute;n del Boleto A&eacute;reo para que los usuarios puedan acceder a dicho 
                  beneficio.</li><br>
                  <li>El usuario no debe haber completado su proceso de Check-In con la aerol&iacute;nea 
                  correspondiente, puesto que, de haberlo realizado no aplicar&aacute; el presente beneficio de 
                  cancelaci&oacute;n gratuita. No obstante, en caso los usuarios se encuentren dentro del mismo 
                  d&iacute;a de emisi&oacute;n del boleto y a su vez ya hayan completado el proceso de Check-In, 
                  podr&aacute;n solicitar directamente a la aerol&iacute;nea emisora del Boleto A&eacute;reo, que el 
                  Check-In realizado sea anulado. Una vez el Check-In haya sido anulado por parte de la 
                  aerol&iacute;nea (dentro del mismo d&iacute;a de emisi&oacute;n del Boleto A&eacute;reo), 
                  el usuario podr&aacute; solicitar la cancelaci&oacute;n del Boleto A&eacute;reo a trav&eacute;s de 
                  la secci&oacute;n MIS VIAJES (en virtud de lo detallado en el presente documento), siempre que 
                  la cancelaci&oacute;n se solicite antes de las 11:45 pm del d&iacute;a de emisi&oacute;n del 
                  Boleto A&eacute;reo. Durante el plazo de 11:45 pm – 11:59 pm del d&iacute;a de emisi&oacute;n 
                  del Boleto A&eacute;reo, los usuarios deber&aacute;n contactarse con soporte de Rappi Travel 
                  para solicitar la cancelaci&oacute;n de gratuita del mismo.</li><br>
                </ol>
                <ul>
                  <li>En caso aplique la cancelaci&oacute;n gratuita, la devoluci&oacute;n del dinero pagado por 
                  el Boleto A&eacute;reo se realizar&aacute; al mismo m&eacute;todo de pago utilizado para efectuar 
                  dicha compra, quedando sujeto a los plazos de devoluci&oacute;n que manejan las entidades bancarias.</li><br>
                  <li>Para poder cancelar un Boleto A&eacute;reo desde la secci&oacute;n MIS VIAJES, el usuario 
                  deber&aacute; seguir los siguientes pasos:</li>
                </ul><br>
                <ol type="a">
                  <li>Deber&aacute; ingresar a la secci&oacute;n “MIS VIAJES”, ubicada dentro de Rappi Travel.</li>
                  <li>En caso el usuario se encuentre dentro del d&iacute;a de emisi&oacute;n del Boleto 
                  A&eacute;reo podr&aacute; tener la opci&oacute;n de cancelarlo sin costo.</li>
                  <li>Una vez seleccionada la opci&oacute;n de cancelar la reserva, ingresar&aacute;n a una 
                  segunda p&aacute;gina donde deber&aacute;n confirmar la acci&oacute;n y as&iacute; se 
                  proceder&aacute; con la cancelaci&oacute;n.</li>
                </ol><br>
                <ul>
                  <li>&Uacute;nicamente el usuario que realiz&oacute; la compra de los Boletos A&eacute;reos 
                  podr&aacute; ser quien solicite la cancelaci&oacute;n de los mismos.</li><br>
                  <li>El presente beneficio se encuentra sujeto a las condiciones y pol&iacute;ticas de cada 
                  aerol&iacute;nea. Es posible que algunas aerol&iacute;neas no permitan cancelaciones a Boletos 
                  A&eacute;reos ya emitidos.</li><br>
                  <li>El presente beneficio &uacute;nicamente aplica para cancelaciones realizadas el mismo 
                  d&iacute;a de emisi&oacute;n del Boleto A&eacute;reo, en casos de casos fortuito o fuerza mayor 
                  donde el usuario requiera solicitar una cancelaci&oacute;n de su Boleto A&eacute;reo de manera 
                  posterior; es decir, d&iacute;as posteriores a la emisi&oacute;n del mismo, deber&aacute; 
                  comunicarse con soporte de Rappi Travel, para que Rappi Travel pueda realizar la solicitud de 
                  manera directa a la aerol&iacute;nea, quedando la cancelaci&oacute;n sujeta a las pol&iacute;ticas 
                  de la aerol&iacute;nea.</li>
                </ul>
          <h3>
            <strong><span>RESERVAS DE VUELOS, TARIFAS ECON&Oacute;MICAS, TURISTAS Y DEM&Aacute;S
                TARIFAS:</span></strong>
          </h3>
          <p><span>Las tarifas a&eacute;reas informadas en el bot&oacute;n denominado
              &ldquo;Rappi Travel&rdquo; dentro de la plataforma de contacto Rappi, mostrar&aacute; la disponibilidad de las
              tarifas m&aacute;s econ&oacute;micas encontradas en el sistema de distribuci&oacute;n (GDS) de las
              aerol&iacute;neas, dichas tarifas cuentan con restricciones tales como: no reembolsables, restricciones de
              cambios,
              cancelaciones, no transferibles entre otras pol&iacute;ticas, las cuales pueden generar cobros adicionales como
              penalidades y/o diferencias de tarifas. Teniendo en cuenta lo anterior es importante que el Usuario verifique las
              pol&iacute;ticas de cambios, cancelaciones y reembolsos antes de aprobar el pago de la reserva, estas condiciones
              son informadas en flujo de la compra. Adicionalmente tenga en cuenta que hay aerol&iacute;neas llamadas e
              identificadas como &ldquo;low cost&rdquo; bajo costo, donde las tarifas publicadas no permiten cancelaciones,
              cambios ni reembolsos, no tienen equipaje facturado de mano ni de bodega o documentable (solo permiten un
              art&iacute;culo personal en las que algunas restricciones de peso y tama&ntilde;o pudieren aplicar), no incluye
              asignaci&oacute;n de silla, alimentaci&oacute;n ni entretenimiento abordo. Todos estos servicios son catalogados
              como adicionales los cuales tienen un costo adicional al valor ya pagado. Teniendo en cuenta lo anterior es
              importante que el Usuario revise de manera atenta las condiciones, restricciones y tarifas de estos servicios ya
              que
              algunos pueden ser adquiridos a trav&eacute;s de la p&aacute;gina web de la aerol&iacute;nea, en el counter o
              abordo. Es importante indicar que Rappi Travel no se encuentra autorizada a variar ni modificar en ning&uacute;n
              caso las regulaciones de los tiquetes a&eacute;reos y/o los valores adicionales cobrados por estas por concepto de
              servicios adicionales.</span></p>
          <h3>
            <strong><span>INFORMACI&Oacute;N DE VUELOS:</span></strong>
          </h3>
          <p><span>Toda la informaci&oacute;n exhibida en Rappi Travel respecto a los Pasajes
              A&eacute;reos ofrecidos (itinerarios, tarifas, etc.) es proporcionada y actualizada en l&iacute;nea y en tiempo
              real
              directamente por cada Compa&ntilde;&iacute;a A&eacute;rea a trav&eacute;s de un sistema global de reservas (Global
              Distribution System o GDS). Las Compa&ntilde;&iacute;as A&eacute;reas, a trav&eacute;s de los GDS son responsables
              exclusivas de actualizar las tarifas, la disponibilidad y los otros datos que aparecen en Rappi Travel. Por este
              motivo, en el per&iacute;odo entre el ingreso de la Solicitud de Compra y la confirmaci&oacute;n del pago o
              emisi&oacute;n del Pasaje A&eacute;reo, las tarifas establecidas por la Compa&ntilde;&iacute;a A&eacute;rea
              podr&iacute;an variar seg&uacute;n disponibilidad. Los precios definitivos quedar&aacute;n fijados a partir del
              momento de la confirmaci&oacute;n definitiva de la reserva que se produce con la emisi&oacute;n de el/los ticket/s
              electr&oacute;nico/s y su facturaci&oacute;n. Rappi Travel no fija tarifas a&eacute;reas ni tiene control sobre la
              disponibilidad de las mismas.</span></p>
          <h3>
            <strong><span>CARGOS DE SERVICIO Y/O PENALIDADES:</span></strong>
          </h3>
          <p><span>Los cargos de penalidad y emisi&oacute;n o tambi&eacute;n conocida como
              cargos de servicio es cobrada por Rappi Travel por pasajero y no ser&aacute; objeto de devoluci&oacute;n</span>
          </p>
          <h3>
            <strong><span>REPROGRAMACIONES, DEMORAS Y/O CANCELACIONES DE VUELOS:</span></strong>
          </h3>
          <p><span>Por razones ajenas a Rappi Travel, las Compa&ntilde;&iacute;as
              A&eacute;reas podr&iacute;an modificar ciertas condiciones de los vuelos como horarios, fechas o itinerarios;
              podr&iacute;an demorarlos y/o reprogramarlos y/o cancelarlos y Rappi Travel no tiene ninguna injerencia ni
              intervenci&oacute;n en relaci&oacute;n con las modificaciones que podr&iacute;an sufrir los vuelos. De producirse
              alguna de estas variaciones antes de las 24 horas de salida del vuelo, por instrucciones del proveedor final, La
              Agencia le informar&aacute; las alternativas disponibles y s&oacute;lo proceder&aacute; a confirmar las
              modificaciones con su expresa confirmaci&oacute;n o aceptaci&oacute;n previa. Cualquier reclamo, demanda o
              denuncia
              por la prestaci&oacute;n del servicio escogido deber&aacute; ser dirigida a la Compa&ntilde;&iacute;a
              A&eacute;rea.
              Recuerde que son las Compa&ntilde;&iacute;as A&eacute;reas las que prestan el servicio de transporte. Dentro de
              las
              24 horas de la salida de su vuelo Rappi Travel no puede realizar gestiones sobre los Pasajes A&eacute;reos. Para
              m&aacute;s informaci&oacute;n sobre los derechos de los pasajeros y compensaciones sobre cancelaciones y/o
              reprogramaciones puede consultar las siguientes normas:&nbsp;Ley N&deg; 29571 (C&oacute;digo de Protecci&oacute;n
              y
              Defensa del Consumidor), la Ley N&deg; 27261 (Ley de Aeron&aacute;utica Civil del Per&uacute;) y la
              Decisi&oacute;n
              N&deg; 619 de la Comunidad Andina.</span></p>
          <h3>
            <strong><span>PRESENTACI&Oacute;N EN EL AEROPUERTO:</span></strong>
          </h3>
          <p><span>Usted deber&aacute; hacerse presente en las oficinas de despacho de la
              Compa&ntilde;&iacute;a A&eacute;rea en el aeropuerto de partida el d&iacute;a previsto y a la hora indicada con la
              Documentaci&oacute;n de Viaje. Para vuelos dom&eacute;sticos aconsejamos presentarse en el aeropuerto con 2 (dos)
              horas de anticipaci&oacute;n y, para vuelos internacionales, la anticipaci&oacute;n deber&aacute; ser de al menos
              3
              (tres) horas. Hay &eacute;pocas donde el flujo de pasajeros en el aeropuerto aumenta, en esos casos de temporada
              alta te recomendamos llegar con mayor anticipaci&oacute;n y revisar el horario de tu vuelo. Tenga presente que los
              horarios que se reflejan en su Pasaje A&eacute;reo est&aacute;n expresados en hora local del pa&iacute;s de escala
              y/o destino. Si Usted no se presenta a embarcar o llega con atraso a embarcar (No Show), la Compa&ntilde;&iacute;a
              A&eacute;rea puede cancelar cualquier reserva para la continuaci&oacute;n del viaje o el retorno y Usted no
              tendr&aacute; derecho a exigir la devoluci&oacute;n total o parcial del importe abonado.</span></p>
          <h3>
            <strong><span>APLICACI&Oacute;N DESISTIMIENTO PARA TIQUETES A&Eacute;REOS.</span></strong>
          </h3>
          <p><span>Si el pasajero decide no realizar el viaje, puede solicitar a La Agencia
              y/o a la aerol&iacute;nea, la devoluci&oacute;n del precio del boleto</span><span><span>, solicitud que
                proceder&aacute; siempre que as&iacute; se encuentre estipulado en el
                boleto y sus </span></span><span>condiciones de la
              cancelaci&oacute;n.</span></p>
          <h3>
            <strong><span>SOLICITUD DE CANCELACI&Oacute;N O CAMBIOS DE FECHA O ITINERARIO:</span></strong>
          </h3>
          <p><span>Destacamos que usualmente las Compa&ntilde;&iacute;as A&eacute;reas
              determinan que las tarifas m&aacute;s econ&oacute;micas sean aquellas que no permiten cambios, cancelaciones ni
              devoluciones, y aun cuando s&iacute; lo permitieran, dichos cambios o cancelaciones est&aacute;n sujetos a
              penalidades. En el caso en que de acuerdo con la reglamentaci&oacute;n dispuesta por la Compa&ntilde;&iacute;a
              A&eacute;rea la tarifa seleccionada por Usted s&iacute; permitiera cancelaciones, Rappi Travel realizar&aacute;
              las
              gestiones de presentaci&oacute;n y seguimiento de su solicitud de cancelaci&oacute;n frente a la
              Compa&ntilde;&iacute;a A&eacute;rea, y ser&aacute; esta quien deber&aacute; proceder a la devoluci&oacute;n. Si lo
              que Usted solicita es un cambio de fecha o itinerario y la tarifa del Pasaje A&eacute;reo adquirido permite
              cambios,
              la Compa&ntilde;&iacute;a A&eacute;rea podr&aacute; establecer una penalidad a abonar la cual es no reembolsable
              y,
              adem&aacute;s, al fijar una nueva fecha o elegir un nuevo itinerario, Usted deber&aacute; abonar la Diferencia de
              Tarifa aplicable al momento del cambio. Los cambios deber&aacute;n realizarse en las mismas clases emitidas o bien
              en clases superiores. Aclaramos que no es posible realizar cambios por tarifas m&aacute;s econ&oacute;micas
              publicadas posteriormente a la emisi&oacute;n del Pasaje A&eacute;reo adquirido. Adem&aacute;s, tanto en el caso
              de
              cambios como de cancelaciones, Rappi Travel podr&aacute; cobrar un Cargo de Gesti&oacute;n adicional.</span></p>
          <h3>
            <strong><span>CAMBIOS EN EL/LOS NOMBRE/S O CAMBIO DE PASAJERO:</span></strong>
          </h3>
          <p><span>El Pasaje A&eacute;reo emitido a nombre del pasajero es nominativo,
              personal e intransferible. Preste mucha atenci&oacute;n al ingresar su/s nombre/s y apellido/s en el/el lugar/es
              indicado/s para ello y en un todo conforme con su Documentaci&oacute;n de Viaje. Usted tiene disponible una
              casilla
              para el/los nombre/s y otro para el/los apellido/s y tiene posibilidad de revisar esta informaci&oacute;n previo a
              confirmar la Solicitud de Compra. Su/s Pasaje/s A&eacute;reo/s se emitir&aacute;/n autom&aacute;ticamente con la
              informaci&oacute;n ingresada por Usted en Rappi Travel sin intervenci&oacute;n manual alguna de parte de La
              Agencia.
              Una vez emitido el/los Pasaje/s A&eacute;reo/s y generado el registro de tiquete electr&oacute;nico, las
              Compa&ntilde;&iacute;as A&eacute;reas no admiten -o en ciertos casos los admiten con costos- cambios de nombres o
              apellidos en un Pasaje A&eacute;reo, ni a&uacute;n en casos de errores de tipo en los nombres de los pasajeros y/o
              de nombres y apellidos invertidos. Si su Pasaje A&eacute;reo contiene alg&uacute;n error, la
              Compa&ntilde;&iacute;a
              A&eacute;rea podr&iacute;a no dejarlo embarcar. La Agencia no se hace responsable por errores y/o inconsistencias
              en
              los Datos Personales por Usted ingresados en Rappi Travel.</span></p>
          <h3>
            <strong><span>TR&Aacute;MITE DE REEMBOLSO.</span></strong>
          </h3>
          <p><span>El tr&aacute;mite del reembolso de un tiquete lo realiza la
              aerol&iacute;nea y el tiempo estimado de reintegro depende de esta, siempre y cuando el tiquete a&eacute;reo sea
              reembolsable. En caso de reembolso, se aplicar&aacute;n las normas y penalidades establecidas por cada
              aerol&iacute;nea con base en el tipo de tarifa y sus restricciones. As&iacute; mismo, en el supuesto de que el
              Usuario solicite la cancelaci&oacute;n y el reembolso de un Servicio Tur&iacute;stico, la Agencia podr&aacute;
              cobrar un cargo de gesti&oacute;n adicional, el cual se realizar&aacute; por tiquete a procesar.</span></p>
          <h3>
            <strong><span>MENORES NO ACOMPA&Ntilde;ADOS:</span></strong>
          </h3>
          <p><span>Se considerar&aacute; &ldquo;menor no acompa&ntilde;ado&rdquo; a aquel que
              viaje sin al menos uno de sus padres o tutores legales. Las Compa&ntilde;&iacute;as A&eacute;reas pueden ofrecer
              servicios de asistencia y acompa&ntilde;amiento (con costo) que, seg&uacute;n el caso, podr&aacute;n ser
              obligatorios u opcionales para aquellos menores que viajen sin acompa&ntilde;ante. Sin embargo, Rappi Travel no
              ofrece este tipo de servicios y no podr&aacute; asegurar el efectivo embarque del menor en el caso de que la
              exigencia fuera obligatoria. Los menores de entre 2 y 7 a&ntilde;os, deber&aacute;n viajar obligatoriamente
              acompa&ntilde;ados por sus padres o responsables a cargo. Normalmente el servicio de &ldquo;menor no
              acompa&ntilde;ado&rdquo; es obligatorio para ni&ntilde;os de entre 8 y 11 a&ntilde;os y opcional para ni&ntilde;os
              de entre 12 y 17 a&ntilde;os. El servicio no est&aacute; disponible para ni&ntilde;os que requieran
              certificaci&oacute;n m&eacute;dica para viajar y/o que no puedan alimentarse y/o que no sean capaces de cubrir sus
              necesidades b&aacute;sicas de higiene y no est&aacute; disponible para itinerarios con escalas o cambios de
              avi&oacute;n. Las restricciones en la prestaci&oacute;n del servicio se pueden consultar en el contrato de
              transporte de la aerol&iacute;nea.</span></p>
          <h3>
            <strong><span>RESTRICCI&Oacute;N DE VENTA DE TIQUETES PARA MENORES.</span></strong>
          </h3>
          <p><span>El Sitio web est&aacute; habilitado para generar reservas de tiquetes
              a&eacute;reos para adultos y ni&ntilde;os, sin embargo, restringe la compra de tiquete para infantes o
              ni&ntilde;os
              que viajen solos, por lo cual si requiere un servicio especial para menores que viajen sin acompa&ntilde;ante
              mayor
              de 18 a&ntilde;os, deber&aacute; ser solicitado por canales de atenci&oacute;n al cliente. Es importante que los
              adultos y los ni&ntilde;os que viajen juntos se encuentren dentro de la misma reserva.</span></p>
          <h3>
            <strong><span>SERVICIOS ESPECIALES:</span></strong>
          </h3>
          <p><span>Son aquellos servicios que se brindan a los pasajeros con base a sus
              necesidades individuales los cuales deben ser solicitados por el Usuario a Rappi Travel como m&iacute;nimo 72
              horas
              de antelaci&oacute;n a la fecha del vuelo, dichos servicios est&aacute;n sujetos a confirmaci&oacute;n por parte
              de
              las l&iacute;neas a&eacute;reas con base a la disponibilidad y en algunas ocasiones estos servicios especiales
              pueden generar costos adicionales.</span></p>
          <h3>
            <strong><span>EQUIPAJE:</span></strong>
          </h3>
          <p><span>Todas las Compa&ntilde;&iacute;as A&eacute;reas tienen diferentes
              pol&iacute;ticas de franquicia de equipaje. Recomendamos revisar las pol&iacute;ticas de equipaje establecidas por
              la l&iacute;nea a&eacute;rea antes de realizar su viaje. Inf&oacute;rmese antes de viajar. Rappi Travel no se
              responsabiliza por robo y/o hurto y/o p&eacute;rdida de equipaje y dem&aacute;s efectos personales de los
              pasajeros.
              En caso de p&eacute;rdida o deterioro de equipaje, Usted debe dirigirse a las oficinas de atenci&oacute;n al
              cliente
              de la Compa&ntilde;&iacute;a A&eacute;rea y realizar el correspondiente reclamo. Abst&eacute;ngase de llevar en el
              equipaje elementos no permitidos, como corto punzante, envases o recipientes que contengan m&aacute;s de 100 ml
              (l&iacute;quidos, geles o aerosoles) en su equipaje de mano para vuelos internacionales, exceptuando medicamentos
              que contengan prescripci&oacute;n m&eacute;dica.</span></p>
          <h3>
            <strong><span>SALUD Y APTITUD PARA EL VIAJE:</span></strong>
          </h3>
          <p><span>Si Usted presenta alguna condici&oacute;n de salud particular, la
              aerol&iacute;nea le exigir&aacute; un certificado m&eacute;dico en original en el cual se especifique la
              autorizaci&oacute;n expresa del doctor que manifieste que el pasajero puede v realizar el viaje. La
              certificaci&oacute;n m&eacute;dica debe tener una fecha de emisi&oacute;n no superior a tres (3) d&iacute;as
              previos
              a la salida del vuelo y/o el plazo que indique la aerol&iacute;nea. Tenga presente que no podr&aacute;n viajar
              solos
              ni con servicio de acompa&ntilde;ante personas que no puedan valerse por s&iacute; solas y/o no est&eacute;n en
              capacidad de seguir instrucciones.</span></p>
          <h3>
            <strong><span>TIQUETES &ldquo;SOLO IDA&rdquo;:</span></strong>
          </h3>
          <p><span>Por disposiciones migratorias de cada pa&iacute;s, en caso de ser no
              residente del pa&iacute;s de destino y contratar por nuestro intermedio un Pasaje A&eacute;reo &uacute;nicamente
              de
              ida, Usted podr&aacute; ser requerido por las autoridades migratorias a justificar las razones por las que no
              cuenta
              con un Pasaje A&eacute;reo de regreso. Le sugerimos consultar al Consulado o Embajada correspondiente antes de
              efectuar la reserva. Las Compa&ntilde;&iacute;as A&eacute;reas tambi&eacute;n podr&aacute;n exigir esta
              documentaci&oacute;n antes de embarcar.</span></p>
          <h3>
            <strong><span>NO SHOW:</span></strong>
          </h3>
          <p><span>Si Usted no se presenta a utilizar su reserva en la fecha y horarios
              indicados (o llega con atraso) Usted no tendr&aacute; derecho a exigir la devoluci&oacute;n total o parcial del
              importe abonado (&ldquo;No Show&rdquo;). Si no va a utilizar su reserva en todo o en parte o si va a llegar con
              retraso a utilizar su reserva, le recomendamos comunicarlo previamente a Rappi Travel para conocer las
              restricciones
              aplicables.</span></p>
          <h3>
            <strong><span>VUELOS O AEROL&Iacute;NEAS LOW-COST:</span></strong>
          </h3>
          <p><span>Tenga presente que cuando reserva un vuelo de una aerol&iacute;nea
              "LOW-COST", la tarifa publicada no permite cambios ni cancelaciones, no incluye reserva de asiento, ni equipaje
              facturado (solo equipaje de mano), ni servicios complementarios tales como refrigerios y/o comidas y/o
              entretenimiento a bordo. Todos estos servicios se consideran adicionales y se ofrecen bajo diferentes condiciones
              seg&uacute;n cada Compa&ntilde;&iacute;a A&eacute;rea y a un costo diferencial. Tenga en cuenta que las
              compa&ntilde;&iacute;as &ldquo;LOW-COST&rdquo; suelen operar en aeropuertos peque&ntilde;os, regionales y/o
              secundarios. Antes de confirmar su Solicitud de Compra, revise atentamente las condiciones y tarifas que son
              informadas para cada caso ya que algunos de los servicios adicionales deben ser reservados y abonados con
              anticipaci&oacute;n mientras que otros pueden ser adquiridos durante el vuelo.</span></p>
          <h3>
            <strong><span>DUPLICIDAD:</span></strong>
          </h3>
          <p><span>Abst&eacute;ngase de generar m&aacute;s de una reserva para el mismo
              destino- pasajero- fecha - hora y aerol&iacute;nea, esto se considera una mala pr&aacute;ctica de duplicidad que
              puede ocasionar una cancelaci&oacute;n de reserva por parte de la aerol&iacute;nea.</span></p>
          <h3>
            <strong><span>HOTELES Y/O ALOJAMIENTO</span></strong>
          </h3>
          <p><span>Cada hotel, hospedaje y/o departamento (el &ldquo;Alojamiento&rdquo;) tiene
              sus propias regulaciones del servicio y tarifarias. Usted firmar&aacute; un contrato directamente con el prestador
              del servicio, trat&aacute;ndose de alojamiento de cualquier tipo; &eacute;ste debe ser firmado a su llegada al
              establecimiento.</span></p>
          <h3>
            <strong><span>RESERVA DE ALOJAMIENTO, TARIFAS:</span></strong>
          </h3>
          <p><span>Muchos Alojamientos ofrecen, para la misma habitaci&oacute;n, una
              &ldquo;tarifa reembolsable&rdquo; o una &ldquo;tarifa no reembolsable&rdquo; (m&aacute;s econ&oacute;mica). Si
              reserva una tarifa &ldquo;no reembolsable&rdquo; el Alojamiento podr&aacute; cobrar el 100% de la estad&iacute;a
              al
              finalizar la compra sin derecho a reembolso alguno, a&uacute;n en casos de que los impedimentos para utilizar el
              hospedaje se deban a razones de fuerza mayor. Si Usted tiene dudas acerca de la posibilidad de utilizar el
              hospedaje, le recomendamos reservar una &ldquo;tarifa reembolsable&rdquo;. Las penalidades que eventualmente se
              informen son cobradas por el Alojamiento. Rappi Travel no cobra penalidades ni Cargos de Gesti&oacute;n
              adicionales
              por cambios y/o cancelaciones. La Agencia le permite al Usuario realizar una reserva y la misma se debe garantizar
              y
              pagar en su totalidad, adicionalmente el pago ser&aacute; validado directamente por un sistema de pago en
              l&iacute;nea, en caso de detectar alguna inconsistencia en la misma, la reserva puede ser cancelada.</span></p>
          <h3>
            <strong><span>CARGOS:</span></strong>
          </h3>
          <p><span>El valor total del alojamiento ser&aacute; liquidado y cargado a la tarjeta
              de cr&eacute;dito o al medio de pago utilizado en el momento de cerrar la reserva.</span></p>
          <h3>
            <strong><span>POL&Iacute;TICAS:</span></strong>
          </h3>
          <p><span>No olvide verificar las pol&iacute;ticas de cancelaci&oacute;n,
              condiciones&nbsp; y restricciones de la tarifa del hotel que est&aacute; reservando.</span></p>
          <h3>
            <strong><span>INFORMACI&Oacute;N DEL ALOJAMIENTO:</span></strong>
          </h3>
          <p><span>La informaci&oacute;n espec&iacute;fica del Alojamiento como nombre,
              ubicaci&oacute;n, categorizaci&oacute;n, horarios de check-in y check-out, y servicios incluidos se encuentra
              suficientemente detallada en Rappi Travel. Le aclaramos que toda la informaci&oacute;n exhibida en Rappi Travel es
              proporcionada y actualizada en l&iacute;nea directamente por cada Proveedor. Ellos son responsables exclusivos de
              actualizar las tarifas, la disponibilidad y los otros datos que aparecen en La Agencia. Rappi Travel no o es ni
              debe
              ser interpretado como un promotor de la calidad, el nivel de servicio y/o la clasificaci&oacute;n de cualquier
              Alojamiento.</span></p>
          <h3>
            <strong><span>CANCELACI&Oacute;N O EXCESO DE RESERVAS DEL ALOJAMIENTO:</span></strong>
          </h3>
          <p><span>Rappi Travel ofrece los Alojamientos seg&uacute;n la disponibilidad
              informada por los Proveedores a trav&eacute;s de un sistema inform&aacute;tico de reservas. En ning&uacute;n caso
              La
              Agencia ofrecer&aacute; un Alojamiento que no otorgue disponibilidad en el sistema. Sin perjuicio de ello, tenga
              presente que el <em>overbooking </em>es una pr&aacute;ctica habitual en el mercado tur&iacute;stico y, en algunos
              pa&iacute;ses, esta pr&aacute;ctica se encuentra regulada. El <em>overbooking </em>puede suceder tambi&eacute;n
              por
              fallos en los sistemas de reservas o fallos humanos. En el caso de que un Alojamiento no pueda respetar su reserva
              en las condiciones contratadas, el Alojamiento deber&aacute; proporcionarle, a su costo, un
              alojamiento/habitaci&oacute;n alternativa/a de calidad igual o superior a la reservada por Usted originalmente.
              Rappi Travel en su car&aacute;cter de intermediario, har&aacute; sus mejores esfuerzos para que Usted pueda
              disfrutar de su estad&iacute;a sin inconvenientes.</span></p>
          <h3>
            <strong><span>PRESENTACI&Oacute;N EN EL ALOJAMIENTO:</span></strong>
          </h3>
          <p><span>Recuerde que, si Usted no se presenta en el Alojamiento en la fecha y
              horario correspondientes, el Alojamiento podr&aacute; cancelar su reserva y considerarla como No Show, en cuyo
              caso
              Usted no tendr&aacute; derecho a exigir el reembolso total o parcial del importe abonado. Si por alguna
              circunstancia Usted va a llegar fuera de los horarios indicados, comun&iacute;quese previamente con el Alojamiento
              y/o con Rappi Travel.</span></p>
          <h3>
            <strong><span>SOLICITUD DE CANCELACI&Oacute;N O CAMBIOS:</span></strong>
          </h3>
          <p><span>La posibilidad de efectuar cambios y/o cancelaciones y, en su caso, las
              penalidades aplicables a cada circunstancia est&aacute;n sujetos a las pol&iacute;ticas del Alojamiento que son
              informadas en Rappi Travel. Cualquier excepci&oacute;n a dichas condiciones deber&aacute; ser autorizada por el
              Alojamiento y/o Proveedor.</span></p>
          <h3>
            <strong><span>MENORES:</span></strong>
          </h3>
          <p><span>Si viaja con menores tiene que incluirlo en la reserva, aun cuando no
              ocupen cama. Recuerde que hay Alojamientos que no aceptan menores.</span></p>
          <h3>
            <strong><span>EQUIPAJE - DEP&Oacute;SITO DE BIENES DE VALOR:</span></strong>
          </h3>
          <p><span>Si Usted lleva consigo efectos de valor superior al que ordinariamente
              llevan los pasajeros, debe hacerlo saber al Alojamiento y guardarlos en las cajas de seguridad que se encuentren a
              disposici&oacute;n en el Alojamiento. La responsabilidad del Alojamiento se limita al valor declarado de los
              efectos
              depositados. Tenga en cuenta que, si sus efectos son excesivamente valiosos en relaci&oacute;n con la importancia
              del Alojamiento, o los mismos causar&aacute;n molestias al Alojamiento, &eacute;ste podr&aacute; negarse a
              recibirlos.</span></p>
          <h3>
            <strong><span>HORARIOS DE CHECK-IN Y CHECK-OUT:</span></strong>
          </h3>
          <p><span>Sin perjuicio de los horarios de check-in y check-out particulares
              informados para cada Alojamiento, la cantidad prevista de d&iacute;as de alojamiento se computa desde el horario
              de
              check-in y finaliza en el horario de check-out del d&iacute;a siguiente, independientemente de la hora de llegada
              y/o de salida, y de la utilizaci&oacute;n completa o fraccionada del mismo. Tenga presente que los horarios que se
              reflejan en el voucher est&aacute;n expresados en horario local del lugar de destino.</span></p>
          <h3>
            <strong><span>AUTOS</span></strong>
          </h3>
          <p><span>Cada empresa rentadora de autos (la/s &ldquo;<u>Rentadora/s</u>&rdquo;)
              tiene sus propias regulaciones del servicio y tarifarias aplicables al alquiler de veh&iacute;culos (el/los
              &ldquo;<u>Auto/s</u>&rdquo;).</span></p>
          <h3>
            <strong><span>RESERVA DE AUTOS, TARIFA:</span></strong>
          </h3>
          <p><span>Rappi Travel garantiza que el precio informado en Rappi Travel para el
              alquiler de Autos incluye la renta del auto por un per&iacute;odo determinado (d&iacute;a, semana, mes),
            </span><span>&nbsp;</span><span>y la totalidad de los
              requisitos y seguros m&iacute;nimos requeridos para retirar el Auto y circular legalmente en el destino elegido,
              sin
              contratar seguros ni elementos adicionales. Salvo que se indique lo contrario en Rappi Travel, la tarifa de renta
              no
              incluye el pago de multas, infracciones, arrastre de gr&uacute;as, gasolina, dejar el Auto en otra ciudad, ni
              cualquier otro servicio adicional.</span></p>
          <h3>
            <strong><span>INFORMACI&Oacute;N DE AUTOS:</span></strong>
          </h3>
          <p><span>Cuando Usted reserva un Auto en Rappi Travel est&aacute; realizando una
              reserva para una clase de Autos, y no para veh&iacute;culos de marcas, a&ntilde;os o modelos espec&iacute;ficos,
              ni
              de caracter&iacute;sticas especiales que no sean comunes a todos los veh&iacute;culos de la clase. La Rentadora
              garantiza el tama&ntilde;o y capacidad del Auto, sin embargo la marca y modelo de los veh&iacute;culos
              est&aacute;n
              sujetos a disponibilidad y ubicaci&oacute;n.</span></p>
          <h3>
            <strong><span>SOLICITUD DE CANCELACI&Oacute;N O CAMBIOS:</span></strong>
          </h3>
          <p><span>De acuerdo a lo establecido por cada Rentadora Usted puede adquirir
              reservas reembolsables y no reembolsables. En el caso de que la reserva adquirida permita reembolso, la reserva
              podr&aacute; ser cancelada en cualquier momento, siempre que Usted notifique a Rappi Travel y/o a la Rentadora su
              voluntad en ese sentido con al menos 24 horas de antelaci&oacute;n al retiro del Auto. Pasado ese plazo no
              podr&aacute;n efectuarse reembolsos. En caso de proceder, los reembolsos se gestionar&aacute;n a trav&eacute;s de
              Rappi Travel, y podr&aacute;n demorar entre 30 y 45 d&iacute;as h&aacute;biles hasta su efectiva
              acreditaci&oacute;n. Sin embargo, las reservas confirmadas y abonadas a trav&eacute;s de Rappi Travel no admiten
              modificaciones por lo que Usted tiene la opci&oacute;n de cancelar sin costo su reserva hasta 24 horas antes del
              retiro del Auto y completar una nueva Solicitud de Compra con las condiciones deseadas.</span></p>
          <h3>
            <strong><span>PER&Iacute;ODO DE ALQUILER - DEVOLUCI&Oacute;N DEL AUTO:</span></strong>
          </h3>
          <p><span>Los per&iacute;odos de alquiler se calculan en bloques de 24 horas. La
              duraci&oacute;n de su alquiler comienza y termina en las fechas que se especifican en su voucher. Cuando el Auto
              fuera retirado o entregado fuera de horas de oficina, la Rentadora podr&aacute; cobrar cargos adicionales. Si
              Usted
              desea prolongar el per&iacute;odo de alquiler o si devuelve el Auto m&aacute;s tarde de la fecha y hora indicada
              en
              su voucher, la Rentadora podr&aacute; aplicar cargos en base a la tarifa diaria local. Le aconsejamos llegar al
              lugar de entrega del Auto con tiempo suficiente. Tenga en cuenta que en el caso que Usted desee devolver el Auto
              alquilado en un lugar distinto al de recogido, la Rentadora podr&aacute; aplicar un recargo adicional excepto
              cuando
              este servicio ya est&eacute; incluido en la reserva adquirida por Usted.</span></p>
          <h3>
            <strong><span>DOCUMENTACI&Oacute;N:</span></strong>
          </h3>
          <p><span>Cuando Usted se presente ante la Rentadora deber&aacute; presentar: (i) el
              voucher de servicio enviado por Rappi Travel; (ii) un permiso de conducci&oacute;n vigente, v&aacute;lido en el
              lugar de destino y expedido con una antig&uuml;edad m&iacute;nima de dos a&ntilde;os; y (iii) una tarjeta de
              cr&eacute;dito internacional con cupo suficiente para hacer frente a la garant&iacute;a. En algunos casos puede
              requerirse el pasaporte. Si Usted va a viajar a un destino internacional, podr&aacute;n exigirle, as&iacute;
              mismo,
              la presentaci&oacute;n de una licencia internacional e interamericana de conducir. Fundamentalmente, podr&aacute;n
              exigirla en el caso de encontrarse Usted involucrado en problemas de tr&aacute;nsito o para acreditar la
              condici&oacute;n de conductor extranjero ante las autoridades de tr&aacute;nsito.</span></p>
          <h3>
            <strong><span>GARANT&Iacute;A:</span></strong>
          </h3>
          <p><span>Usted deber&aacute; presentar una tarjeta de cr&eacute;dito internacional a
              nombre del conductor al momento de retirar el Auto. En la misma, la Rentadora realizar&aacute; el bloqueo del
              monto
              correspondiente a la franquicia a modo de garant&iacute;a que podr&aacute; ser de hasta el doble de la tarifa
              abonada o a abonar por el alquiler del Auto.</span></p>
          <h3>
            <strong><span>CARGOS ADICIONALES:</span></strong>
          </h3>
          <p><span>Le hacemos saber que durante el desarrollo del per&iacute;odo locativo, se
              podr&iacute;an generar cargos o d&eacute;bitos a su cargo no reclamados por la Rentadora en forma inmediata (como
              multas por infracciones de tr&aacute;nsito o da&ntilde;os, roturas o faltantes sufridos por el Auto). Usted
              deber&aacute; abonar dichas multas y cargos adicionales cuando le sean reclamados por la Rentadora. Estos cargos
              adicionales dependen de las pol&iacute;ticas de cada Rentadora y son cobrados directamente por esta sin
              intervenci&oacute;n ni injerencia alguna de Rappi Travel.</span></p>
          <h3>
            <strong><span>SEGUROS Y SERVICIOS ADICIONALES CONTRATADOS EN DESTINO:</span></strong>
          </h3>
          <p><span>En destino, la Rentadora podr&iacute;a ofrecerle contratar servicios
              adicionales (tales como seguros con p&oacute;lizas de mayor cobertura, cuota de recuperaci&oacute;n de, cargo por
              gasolina, cargo por conductor adicional, GPS, asientos para menores, etc), los que ser&aacute;n contratados
              directamente por Usted y cobrados por la Rentadora sin intervenci&oacute;n de Rappi Travel. La contrataci&oacute;n
              de tales adicionales es voluntaria y ajena a Rappi Travel, quien no es responsable por los valores que Usted deba
              abonar por tales conceptos.</span></p>
          <h3>
            <strong><span>IMPUESTOS Y TASAS:</span></strong>
          </h3>
          <p><span>En ciertos destinos, el servicio adquirido no incluye impuestos locales y/o
              recargos estatales, que Usted deber&aacute; abonar al momento de retirar el Auto, directamente a la Rentadora.
              Esta
              situaci&oacute;n le ser&aacute; suficientemente informada en Rappi Travel.</span></p>
          <h3>
            <strong><span>PEAJES:</span></strong>
          </h3>
          <p><span>En ciertas jurisdicciones Usted podr&aacute; contratar directamente con la
              Rentadora un servicio de telepeaje (como por ejemplo, el SUN PASS en el estado de Florida, en Estados Unidos), que
              le permitir&aacute; trasladarse c&oacute;modamente y evitar multas. Ese servicio podr&aacute; ser libremente
              contratado por Usted directamente a la Rentadora. Reiteramos que Rappi Travel no se hace responsable por tales
              conceptos y valores.</span></p>
          <h3>
            <strong><span>CONDUCTORES MENORES DE 26 A&Ntilde;OS:</span></strong>
          </h3>
          <p><span>En algunos destinos, las Rentadoras tienen pol&iacute;ticas para
              conductores con edades entre 21 y 26 a&ntilde;os, en las cuales podr&aacute;n regir restricciones y/o cargos
              adicionales que deber&aacute;n abonarse en destino. Dichos importes no se encuentran incluidos en la
              tarifa.</span>
          </p>
          <h3>
            <strong><span>JURISDICCI&Oacute;N EXTRA&Ntilde;A:</span></strong>
          </h3>
          <p><span>Si Usted planea cruzar una frontera estatal, aseg&uacute;rese antes de
              completar su Solicitud de Compra que el Auto est&eacute; autorizado para transitar por tal destino. Algunas
              Rentadoras pueden prohibir o cobrar un adicional por transitar en una jurisdicci&oacute;n extra&ntilde;a. Revise
              las
              condiciones que establezca la Rentadora en este punto.</span></p>
          <h3>
            <strong><span>ACTIVIDADES Y TRASLADOS</span></strong>
          </h3>
          <p><span>Tenga muy presente que cada operador tur&iacute;stico (el/los
              &ldquo;<u>Operador/es</u>&rdquo;) tiene sus propias regulaciones del servicio y tarifarias aplicables a las
              actividades, excursiones, traslados, tickets y atracciones que proveen (la/s
              &ldquo;<u>Actividad/es</u>&rdquo;)</span></p>
          <h3>
            <strong><span>HORARIOS:</span></strong>
          </h3>
          <p><span>Sin perjuicio de los horarios particulares informados para cada Actividad
              en Rappi Travel, los horarios de apertura y cierre de algunas atracciones var&iacute;an seg&uacute;n el periodo
              del
              a&ntilde;o. Se aconseja contactar con la atracci&oacute;n en cuesti&oacute;n antes de visitarla, para confirmar
              los
              horarios aplicables en la fecha en que Usted tenga planeado hacerlo. Tenga presente que los horarios que se
              reflejan
              en el voucher est&aacute;n expresados en horario local del lugar de destino</span></p>
          <h3>
            <strong><span>CONTACTO CON EL OPERADOR:</span></strong>
          </h3>
          <p><span>En algunos casos se le solicitar&aacute; que, previo a la fecha para hacer
              uso de la Actividad, Usted se comunique con el Operador para confirmar algunos detalles y/o coordinar el punto de
              encuentro y/o solicitar los vouchers definitivos sin los cuales Ud. no podr&aacute; hacer uso del servicio. Si
              Usted
              no realiza este contacto en tiempo y forma y, en virtud de ello, Usted ve frustrado el uso y goce del servicio,
              Rappi Travel no se har&aacute; responsable y Usted no tendr&aacute; derecho a exigir reembolso alguno por parte de
              Rappi Travel y/o el Operador.</span></p>
          <h3>
            <strong><span>ACTIVIDADES RIESGOSAS:</span></strong>
          </h3>
          <p><span>en los casos en los que la Actividad contratada sea una actividad de
              riesgo, Usted asume el riesgo de participar en la Actividad y Usted declara estar sano y gozar de buena salud
              f&iacute;sica, mental y estar debidamente entrenado para participar de esa Actividad. Mediante el presente, Usted
              acepta y asume la total responsabilidad por cualquier y todos los riesgos de enfermedad, herida o muerte (no por
              descuidada, premeditada o fraudulenta conducta) que pudiesen ocurrir en el desarrollo de la Actividad.</span></p>
          <h3>
            <strong><span>RESPONSABILIDAD:</span></strong>
          </h3>
          <p><span>Rappi Travel no ser&aacute; responsable de las condiciones de las
              atracciones o lugares, ni de actos de comisi&oacute;n u omisi&oacute;n por parte de terceros en cualquier
              Actividad,
              lugar o servicio.</span></p>
          <h3>
            <strong><span>BUSES</span></strong>
          </h3>
          <p><span>Tenga muy presente que cada empresa de buses (la/ &ldquo;<u>Empresa/s de
                buses</u>&rdquo;) tiene sus propias regulaciones de servicio y tarifarias para el transporte de pasajeros en bus
              (el &ldquo;<u>bus</u>&rdquo;).</span></p>
          <h3>
            <strong><span>RESERVAS DE BUSES, TARIFAS:</span></strong>
          </h3>
          <p><span>Una vez confirmada la Solicitud de Compra, Usted recibir&aacute; un e-mail
              con el boleto de bus (el &ldquo;<u>Boleto</u>&rdquo;), que podr&aacute; imprimir y llevar con Usted a la terminal
              junto con la Documentaci&oacute;n de Viaje de cada pasajero. Al momento de viajar, es necesario contar con el
              Boleto
              impreso para ser presentado ante el conductor, quedando un tal&oacute;n del mismo en poder del pasajero como
              comprobante de viaje, as&iacute; como tambi&eacute;n es necesario presentar la Documentaci&oacute;n de Viaje
              correspondiente que permita acreditar identidad. Si los datos ingresados de los pasajeros no coinciden con la
              Documentaci&oacute;n de Viaje que se presenta antes de subir al bus, no podr&aacute; viajar. Las Empresas de buses
              se reservan el derecho de brindar el servicio adquirido mediante otra firma cuando razones t&eacute;cnicas u
              operativas le impidan hacerlo con sus unidades, debiendo respetar precio, calidad y categor&iacute;a de servicio.
              Ello no se aplica cuando existan razones de fuerza mayor o caso fortuito.</span></p>
          <h3>
            <strong><span>CANCELACIONES, REPROGRAMACIONES O DEMORAS DEL TRANSPORTE EN BUS:</span></strong>
          </h3>
          <p><span>Ni Rappi Travel ni la Empresa de buses se har&aacute;n responsable por
              gastos o perjuicios provocados por la demora en la salida, llegada o interrupciones durante el viaje cuando ello
              se
              deba a un caso fortuito o fuerza mayor (tales como condiciones meteorol&oacute;gicas adversas, cierres de los
              pasos
              fronterizos o cortes de ruta).</span></p>
          <h3>
            <strong><span>CANCELACI&Oacute;N SOLICITADA POR EL PASAJERO:</span></strong>
          </h3>
          <h3>
            <span>De acuerdo a lo establecido por cada Operadora Usted puede adquirir reservas reembolsables
              y no reembolsables. En el caso de que la reserva adquirida permita reembolso, la reserva podr&aacute; ser
              cancelada
              en cualquier momento, siempre que Usted notifique a Rappi Travel su voluntad en ese sentido con al menos 24 horas
              de
              antelaci&oacute;n al inicio del viaje. Pasado ese plazo no podr&aacute;n efectuarse reembolsos. En caso de
              proceder,
              los reembolsos se gestionar&aacute;n a trav&eacute;s de Rappi Travel, y podr&aacute;n demorar entre 30 y 45
              d&iacute;as h&aacute;biles hasta su efectiva acreditaci&oacute;n. Sin embargo, las reservas confirmadas y abonadas
              a
              trav&eacute;s de Rappi Travel no admiten modificaciones por lo que Usted tiene la opci&oacute;n de cancelar sin
              costo su reserva hasta 24 horas antes del inicio del viaje y completar una nueva Solicitud de Compra con las
              condiciones deseadas.</span><strong><span>CAMBIO SOLICITADO POR EL PASAJERO:</span></strong>
          </h3>
          <p><span>&nbsp;</span><span>est&aacute;n sujetos a la
              disponibilidad del nuevo viaje y a cambios en la tarifa que deber&aacute;n ser asumidos por el
              Usuario/Consumidor</span><span>. Las Empresas de buses no admiten cambios
              de nombres o apellidos en un Boleto, ni a&uacute;n en casos de errores de tipeo en los nombres de los pasajeros.
              Preste mucha atenci&oacute;n al ingresar su/s nombre/s y apellido/s en el lugar indicado para ello y en un todo
              conforme con su Documentaci&oacute;n de Viaje.</span></p>
          <h3>
            <strong><span>PRESENTACI&Oacute;N EN LA TERMINAL:</span></strong>
          </h3>
          <p><span>Le aconsejamos presentarse en la terminal con al menos cincuenta minutos de
              anticipaci&oacute;n a la hora de partida de su viaje. Si Usted no se presenta a embarcar o llega con atraso a
              embarcar (No Show), la Compa&ntilde;&iacute;a de buses puede cancelar cualquier reserva para la
              continuaci&oacute;n
              del viaje o el retorno y Usted no tendr&aacute; derecho a exigir la devoluci&oacute;n total o parcial del importe
              abonado.</span></p>
          <h3>
            <strong><span>MENORES:</span></strong>
          </h3>
          <p><span><span>Cada operadora informar&aacute; el rango de edad de los
                ni&ntilde;os que deber&aacute;n pagar la totalidad del pasaje.</span></span><span>&nbsp;</span></p>
          <p><span>En el caso de viajar con menores de edad adem&aacute;s del documento de
              viaje habilitado (Documento Nacional de Identidad o Pasaporte), necesitan Autorizaci&oacute;n de Viaje para
              menores
              de edad (documento certificado notarialmente por el cual los padres autorizan el viaje de su hijo menor de edad
              dentro o fuera del territorio peruano, para que viaje solo, acompa&ntilde;ado por uno de ellos o por otro adulto)
              que debe tener la firma del notario y tambi&eacute;n: Dentro del pa&iacute;s (i) si el menor viaja solo: la firma
              de
              uno de los padres , (ii) Si el menor viaja con uno de los padres dentro del pa&iacute;s: no se necesita permiso y
              Fuera del pa&iacute;s (i) Si el menor viaja solo: la firma de ambos padres, (ii) Si el menor viaja con uno de los
              padres: la firma del padre o madre que no lo acompa&ntilde;a, (iii) Si el menor viaja con un tercero: la firma de
              ambos padres. La autorizaci&oacute;n tiene una vigencia de 90 d&iacute;as y debe ser entregada a la Empresa de Bus
              o
              a la autoridad migratoria peruana para que permita la salida del pa&iacute;s del menor y es v&aacute;lida solo por
              una vez. </span></p>
          <p><span>Asimismo, dentro del pa&iacute;s se requiere presentar (i) Partida de
              nacimiento original y actualizada del menor, (ii) DNI del menor de edad, (iii) DNI del padre o de la madre, (iv)
              En
              caso de fallecimiento de uno de los padres o si el hijo est&aacute; reconocido solo por uno de ellos,
              bastar&aacute;
              el consentimiento del padre que sobreviva o de aquel que efectu&oacute; el reconocimiento (el permiso notarial
              debe
              constar haber tenido a la vista la partida de defunci&oacute;n o la de nacimiento correspondiente. </span></p>
          <p><span>En caso de viaje fuera del pa&iacute;s, se requiere presentar (i) Partida
              de nacimiento original y copia del menor de edad, (ii) DNI/Pasaporte del menor de edad, (iii) DNI/Pasaporte de los
              padres, (iii) En el caso de padre extranjeros: el documento de identidad o pasaporte que lo identifique, (iv)
              Cuando
              solo uno de sus padres ha reconocido al menor: basta con el consentimiento de este, (v) Cuando uno de los padres
              ha
              fallecido: copia del acta de defunci&oacute;n, (vi) Si el menor tiene un apoderado: poder y otros documentos que
              lo
              acrediten como tal, (vii) Si uno de los padres se encuentra en el extranjero: Autorizaci&oacute;n de viaje
              consular
              y luego legalizarla en el Ministerio de Relaciones Exteriores del Per&uacute;. (viii) Si el menor cuyo padre o
              madre
              est&aacute; en el extranjero va a viajar con una tercera persona: Autorizaci&oacute;n de viaje consular otorgada
              por
              el padre que est&aacute; fuera del pa&iacute;s, legalizada en el Ministerio de Relaciones Exteriores, y la
              Autorizaci&oacute;n de Viaje Notarial del padre que permanece en el Per&uacute; (el padre que est&aacute; en el
              Per&uacute; y viajar&aacute; con el menor solo necesita la Autorizaci&oacute;n de Viaje Consular legalizada para
              salir del pa&iacute;s con su hijo). Es importante que los datos del documento del menor coincidan con los
              documentos
              presentados por los padres.</span></p>
          <p><span>Les recomendamos a los pasajeros que viajen acorde a alguna de las
              modalidades mencionadas en este punto, presentarse en la terminal con mayor anticipaci&oacute;n a lo aconsejado
              para
              una correcta verificaci&oacute;n de la Documentaci&oacute;n de Viaje.</span></p>
          <h3>
            <strong><span>FRANQUICIAS DE EQUIPAJE:</span></strong>
          </h3>
          <p><span>&nbsp;</span></p>
          <h3>
            <strong><span>MASCOTAS:</span></strong>
          </h3>
          <p><span>&nbsp;</span><span>.</span><span><span> Sin embargo cada empresa de buses podr&aacute; modificar
                esta pol&iacute;tica y la informar&aacute; en el proceso de reserva. Consulte con la Empresa de buses por costos
                en caso de transporte de mascotas</span>&nbsp;</span></p>
          <p><span>&nbsp;</span></p>
          <h3>
            <strong><span>MATERIALES NO PERMITIDOS:</span></strong>
          </h3>
          <p><span>No pueden ingresar a los buses materiales inflamables, corrosivos,
              explosivos o peligrosos en general.</span></p>
          <h3>
            <strong><span>COSAS DE VALOR:</span></strong>
          </h3>
          <p><span>Ni Rappi Travel ni la Empresa de buses responden por p&eacute;rdida o
              da&ntilde;os sufridos por objetos de valor extraordinario que el pasajero lleve consigo, y no haya declarado antes
              del inicio del viaje. Las mencionadas empresas tampoco son responsables por la p&eacute;rdida de equipaje de mano
              y
              de los dem&aacute;s efectos personales que hayan quedado bajo la custodia del pasajero, salvo culpa del
              transportista.</span></p>
          <h3>
            <strong><span>BOLETO &ldquo;SOLO IDA&rdquo;:</span></strong>
          </h3>
          <p><span>Por disposiciones migratorias de cada pa&iacute;s, en caso de ser no
              residente del pa&iacute;s de destino y contratar por nuestro intermedio un Boleto &uacute;nicamente de ida, Usted
              podr&aacute; ser requerido por las autoridades migratorias a justificar las razones por las que no cuenta con un
              pasaje de regreso. Le sugerimos consultar al Consulado o Embajada correspondiente antes de efectuar la
              reserva.</span></p>
          <h3>
            <strong><span>PAQUETES</span></strong>
          </h3>
          <p><span>En la secci&oacute;n &ldquo;Paquetes&rdquo; de Rappi Travel, Usted puede
              armar un viaje din&aacute;mico. El viaje din&aacute;mico permite sumar todos los Servicios que Usted desee
              adquirir
              siguiendo la modalidad de &ldquo;carrito de compras&rdquo; y abonar en un solo pago todos los Servicios. Con la
              modalidad &ldquo;carrito de compras&rdquo; Usted puede ir buscando y seleccionando distintos Servicios (vuelos +
              alojamientos + actividades + seguros + traslados + buses y/o cualquier combinaci&oacute;n entre ellos)
              seg&uacute;n
              sus gustos y necesidades, realizando una sola b&uacute;squeda y reservando tantos Servicios como Usted desee.
              Rappi
              Travel simplemente act&uacute;a como intermediario mostrando las opciones disponibles y posibilitando que Usted
              seleccione los Servicios, Proveedores y combinaciones de Servicios seg&uacute;n sus propios gustos y necesidades,
              pero sin dejar de actuar como un intermediario. </span></p>
          <h3>
            <strong><span>RAPPI TRAVEL NO ES ORGANIZADOR DE PAQUETES:</span></strong>
          </h3>
          <p><span>Rappi Travel no organiza Paquetes ni asesora o intenta vender un Servicio
              y/o un Proveedor espec&iacute;fico respecto de otro. Usted puede visualizar en Rappi Travel todas las opciones
              disponibles para construir su propio viaje combinando -vuelos, alojamiento, alquiler de autos y/o traslados- en
              lugar de comprar un paquete predefinido o cerrado. Rappi Travel puede sugerir Paquetes combinando Servicios para
              facilitar su b&uacute;squeda. Sin embargo, Usted puede modificar cualquiera de esos Servicios en cualquier momento
              antes de la compra para que el Paquete se adapte a sus necesidades. Recuerde que Rappi Travel no act&uacute;a como
              organizador, ya que no es quien elige y/o combina los Servicios o decide cual ser&aacute; el prestador y/o
              dise&ntilde;a los horarios.</span></p>
          <h3>
            <strong><span>MODALIDAD DE RESERVA DE PAQUETES:</span></strong>
          </h3>
          <p><span>El proceso para armar su Paquete es muy sencillo y consta de 3 pasos: (i)
              Se ingresa a la secci&oacute;n de Paquetes y se definen las fechas de viaje y destino de viaje. (ii) Se
              seleccionan
              los Servicios, como vuelo, alojamiento, alquileres de autos, o cualquier otro producto. (iii) Antes de pagar, es
              necesario confirmar la compra de cada uno de los productos seleccionados y se elige alguna opci&oacute;n de
              pago.</span></p>
          <h3>
            <strong><span>POL&Iacute;TICAS DE CANCELACI&Oacute;N Y CAMBIO DE CADA SERVICIO:</span></strong>
          </h3>
          <p><span>Recuerde que cada Servicio seleccionado por Usted para armar su Paquete se
              rige por sus propias condiciones de cambio y/o cancelaci&oacute;n establecidas por cada Proveedor y que la
              modificaci&oacute;n y/o cancelaci&oacute;n de un Servicio no afecta, en modo alguno, a los dem&aacute;s Servicios
              contratados que se regir&aacute;n por sus propias condiciones y que deber&aacute;n ser modificados y/o cancelados
              individualmente siempre que las condiciones del Proveedor lo permitan.</span></p>
        </div> 
        `
      ]
    },
  ]
};
